// Mock data for Michael Pedalino's landing page

export const personalInfo = {
  name: "Michael Pedalino",
  title: "Account Manager / Customer Success Manager",
  location: "North Fort Myers, FL",
  email: "mpedalino@gmail.com",
  phone: "(518) 810-6803",
  tagline: "High-performing professional delivering exceptional customer experiences and driving revenue growth"
};

export const professionalSummary = {
  headline: "Driving Results Through Customer-Centric Solutions",
  description: "High-performing Account Manager / Customer Success Manager with extensive experience responding to inquiries, resolving issues, processing transactions, and maintaining accurate customer records. Proven at delivering personalized support, building loyalty through attentive follow-up, and adhering to company procedures while working collaboratively with teams.",
  highlights: [
    "Generated $800,000+ in sales revenue through consultative selling",
    "Achieved 100% client retention across 52 SMB accounts",
    "Exceeded revenue targets of $1.6M+ across territory",
    "Closed 40+ new customers per month consistently"
  ]
};

export const keyStrengths = [
  {
    title: "Customer Success",
    description: "Expert at building lasting relationships and ensuring client satisfaction through personalized support",
    icon: "Users"
  },
  {
    title: "Revenue Generation",
    description: "Proven track record of exceeding sales targets and driving business growth",
    icon: "TrendingUp"
  },
  {
    title: "Problem Solving",
    description: "Strong analytical skills with attention to detail in fast-paced environments",
    icon: "Target"
  },
  {
    title: "Relationship Building",
    description: "Skilled at networking, lead generation, and maintaining strong client partnerships",
    icon: "Handshake"
  }
];

export const experience = [
  {
    role: "Sales Team Member",
    company: "ABC Fine Wine & Spirits",
    location: "Fort Myers, FL",
    period: "04/2025 - 11/2025",
    achievements: [
      "Deliver top-tier customer service, enhancing client satisfaction and loyalty",
      "Master product details to provide tailored recommendations boosting sales",
      "Fostered a welcoming environment contributing to repeat business"
    ]
  },
  {
    role: "Sales Agent",
    company: "Marcia Murray & Associates Realty",
    location: "Clifton Park, Naples, FL",
    period: "01/2010 - 02/2025",
    achievements: [
      "Generated new business through networking and social media marketing",
      "Conducted market analysis and provided clients with market trends",
      "Built and maintained strong network of clients and referrals"
    ]
  },
  {
    role: "Account Manager / Customer Success Manager",
    company: "Tech Service Today",
    location: "Boynton Beach, FL (Remote)",
    period: "09/2021 - 12/2022",
    achievements: [
      "Increased profitability by generating $800,000 in sales",
      "Owned portfolio of 52 SMB accounts with 100% retention",
      "Led value-based selling discussions with key stakeholders",
      "Used Salesforce CRM for pipeline management and forecasting"
    ]
  }
];

export const skills = [
  "Account Management",
  "Customer Success",
  "Sales & Business Development",
  "Salesforce CRM",
  "Relationship Building",
  "Problem Solving",
  "Microsoft Office",
  "Digital Marketing",
  "Negotiation",
  "Data Analysis"
];

export const certifications = [
  "Google Adwords Certification",
  "Google Analytics Certification",
  "NYS Licensed Real Estate Sales Professional",
  "Certified Digital Marketing Professional",
  "A+ Certification"
];

export const education = {
  degree: "Bachelor of Science (B.S.) Business Administration - Finance",
  institution: "Union College, Schenectady, NY"
};
